
export const name = "academy-public-ui";
export const version = "dev";
